export enum SortOrders {
    Recent,
    Oldest,
    LowestSalary,
    HighestSalary
}